<template>
  	<footer class="w-100 footer-container mt-5">
		<div class="footer-icons mt-2">
			<a href="">
				<i class="mx-2 fab fa-linkedin-in"></i>
			</a>
			<a href="">
				<i class="mx-2 fab fa-facebook"></i>
			</a>
			<a href="">
				<i class="mx-2 fab fa-instagram"></i>
			</a>
			<a href="">
				<i class="mx-2 fab fa-youtube"></i>
			</a>
		</div>
		<p class="footer-text">© Copyright 2021 Metodologia Instant. Todos os direitos reservados.
		</p>
	</footer>
</template>

<script>
export default {
	name: 'Footer'
}
</script>

<style>

</style>